import { get } from '@apps/firsthomecoach/src/api/utils';

export const getRepeaters = params => get(`/content/repeaters?keys=${params}`);
export const getRepeater = ({ key, encodedParams = '' }) => get(`/content/custom-repeater/${key}${encodedParams}`);

export const repeaters = { getRepeaters, getRepeater };
